export default __webpack_public_path__ + "static/media/error-exclamation.313bddb1.svg";